import React, { useState, createContext } from 'react';

const FormContext = createContext();
function FormProvider(props) {
	const [forms, setForms] = useState([]);
	return (
		<FormContext.Provider value={[forms, setForms]}>
			{props.children}
		</FormContext.Provider>
	);
}

export { FormContext, FormProvider };